import { AxiosResponse } from 'axios';
import apiClient from './api';

const authService = {
  login: (email: string, password: string, loggedUsers: any): Promise<AxiosResponse<any>> => {
    return apiClient.post(`/authentication/login`,
      {Email: email, Password: password, StorageLogins: loggedUsers },
      {withCredentials: true});
  },

  logout: (): Promise<AxiosResponse<any>> => {
    return apiClient.post(`/authentication/logout`);
  },

  refresh: (): Promise<AxiosResponse<any>> => {
    return apiClient.get(`/authentication/refresh`);
  },

  checkAuthTime: (): Promise<AxiosResponse<any>> => {
    return apiClient.get(`/authentication/properties`);
  },

  verifyCode: (userID: number, code: string): Promise<AxiosResponse<any>> => {
    return apiClient.post(`/authentication/twoFactorCode`, {
      UserID: userID,
      Digits: code
    },
  {withCredentials: true});
  },

  checkPassword: (email: string, password: string): Promise<AxiosResponse<any>> => {
    return apiClient.post(`/authentication/password`, {Email: email, Password: password});
  }
};

export default authService;

